import store from "@utils/redux/store";
import { trackEvent } from "@utils/api/tracker";
import { registerHandler } from "../handler";
import extractFieldsFromURLParams from "../../urlParams";

export default function registerHandlers() {
  registerHandler("purchase", () => {
    // For the healthline pixel the revenue is hardcoded.
    const { geoLocation } = store.getState();
    let revenue = geoLocation.country_code === "US" ? 40 : 30;
    const { clid, utm_campaign } = extractFieldsFromURLParams([
      "clid",
      "utm_campaign",
    ]);

    if (utm_campaign === "cpm") {
      revenue = 0;
    }

    const healthLineURL = new URL(
      "https://activation.healthline.com/api/member-offers/postback"
    );
    healthLineURL.searchParams.append("clid", clid || "-1");
    healthLineURL.searchParams.append("rev", revenue.toString());

    fetch(healthLineURL.toString())
      .then((response) => {
        if (response.ok) {
          trackEvent("HealthlineSignup");
        } else {
          trackEvent("HealthlineFail");
        }
      })
      .catch(() => {
        trackEvent("HealthlineFail");
      });
  });
}
